import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { StoreNotLoading } from '../core/states/store.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
  partnerPlatformURL = environment.platformURL;
  requestedPath = location.pathname;

  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(new StoreNotLoading());
  }
}
